// Libs
import { Box } from '@mui/material';
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// Components, Layouts, Pages
import { BaseToolbar } from '~/components/common';
import PageShell from '~/pages/common/pageShell/PageShell';
import { ReportItem } from '~/components/module/report';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { reportList } from '~/utils/constants/component';
import { StorageEnum } from '~/utils/enum/base';
import { ReportItemEnum, RoleEnum } from '~/utils/enum/common';
import { adminRouteAbsolute } from '~/utils/routes/admin';
import { staffRouteAbsolute } from '~/utils/routes/staff';
// Styles, images, icons
import styles from './Report.module.scss';

const cx = classNames.bind(styles);

const Report = () => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/report', 'common/base']);
  const navigate = useNavigate();

  const role = localStorage.getItem(StorageEnum.ROLE) || EMPTY_STRING;
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const reportRoutes: Record<string, Record<string, string>> = {
    [ReportItemEnum.TECHNICIAN_PERFORMANCE]: {
      [RoleEnum.ADMIN]: adminRouteAbsolute.technicianReport,
      [RoleEnum.STAFF]: staffRouteAbsolute.technicianReport,
    },
    [ReportItemEnum.SALE_BY_CITY]: {
      [RoleEnum.ADMIN]: adminRouteAbsolute.saleByCityReport,
      [RoleEnum.STAFF]: staffRouteAbsolute.saleByCityReport,
    },
    [ReportItemEnum.SERVICE_VOLUME]: {
      [RoleEnum.ADMIN]: adminRouteAbsolute.serviceVolumeReport,
      [RoleEnum.STAFF]: staffRouteAbsolute.serviceVolumeReport,
    },
    [ReportItemEnum.PER_CALL_AVERAGE]: {
      [RoleEnum.ADMIN]: adminRouteAbsolute.perCallAverageReport,
      [RoleEnum.STAFF]: staffRouteAbsolute.perCallAverageReport,
    },
    [ReportItemEnum.PO_PER_PAY_PERIOD]: {
      [RoleEnum.ADMIN]: adminRouteAbsolute.poPerPayPeriodReport,
      [RoleEnum.STAFF]: staffRouteAbsolute.poPerPayPeriodReport,
    },
  };

  const handleClickItem = (type: string) => {
    const route = reportRoutes[type]?.[role];
    if (!route) return;
    navigate(route);
  };
  //#endregion Handle Function

  return (
    <PageShell title={t('report_page_title')}>
    <Box component={'div'} id='reportPage' className={cx('container')}>
      <BaseToolbar />

      <Box component={'div'} className={cx('body')}>
        {reportList(t).map((reportItem) => (
          <ReportItem key={reportItem.type} {...reportItem} onClick={handleClickItem} />
        ))}
      </Box>
    </Box>
    </PageShell>
  );
};

export default Report;
